import React from 'react';
import '../../assets/scss/projectTable.scss';
import { ReactComponent as CrossIcon } from '../../assets/svg/Project/close.svg';
import { ReactComponent as CheckIcon } from '../../assets/svg/partial-access.svg';
import { ReactComponent as FullAccess } from '../../assets/svg/full-access.svg';
import moment from 'moment';
import _ from 'lodash';

class TenantUsersListTableRow extends React.Component {
	constructor(props) {
		super();
		this.state = {
			isShooter: props.data.isShooter == true ? true : false,
		};
	}
	handleShooter = (e, type) => {
		this.setState(
			{
				isShooter: type,
			},
			() => {
				this.props.handleIsShooter(e, type);
			},
		);
	};
	render() {
		return (
			<tr height={40}>
				<td className="wedding-details-column" onClick={this.props.handleTenantUserClick}>
					<div
						style={{
							height: '100%',
							position: 'relative',
						}}
					>
						<div className="wedding-details wedding-details-center">
							<div className="lower-wed">
								<span className="date" style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px' }}>
									{this.props.data.displayName}
									{this.props.data.isSuspended && (
										<span className="suspended-chip">Suspended</span>
									)}
								</span>
							</div>
							<div className="upper-wed">
								<span className="date" style={{ width: '100%', display: 'flex' }}>
									{this.props.data.fullName}
								</span>
							</div>
						</div>
					</div>
				</td>
				<td className="wedding-details-column" onClick={this.props.handleTenantUserClick}>
					<div
						style={{
							height: '100%',
							position: 'relative',
						}}
					>
						<div className="wedding-details wedding-details-center">
							<div className="upper-wed">
								<span className="date" style={{ width: '100%', display: 'flex' }}>
									{this.props.data.phoneNumber}
								</span>
							</div>
						</div>
					</div>
				</td>
				<td className="wedding-details-column" onClick={this.props.handleTenantUserClick}>
					<div
						style={{
							height: '100%',
							position: 'relative',
						}}
					>
						<div className="wedding-details wedding-details-center">
							<div className="upper-wed">
								<span className="date" style={{ width: '100%', display: 'flex' }}>
									{this.props.data.eventEqs}
								</span>
							</div>
						</div>
					</div>
				</td>
				{/* <td className="wedding-details-column" onClick={this.props.handleTenantUserClick}>
					<div
						style={{
							height: '100%',
							position: 'relative',
						}}
					>
						<div className="wedding-details wedding-details-center">
							<div className="upper-wed">
								<span className="date" style={{ width: '100%', display: 'flex' }}>
									{this.props.data.individualEqs}
								</span>
							</div>
						</div>
					</div>
				</td> */}
				<td className="wedding-details-column" onClick={this.props.handleTenantUserClick}>
					<div
						style={{
							height: '100%',
							position: 'relative',
						}}
					>
						<div className="wedding-details wedding-details-center">
							<div className="upper-wed">
								<span className="date" style={{ width: '100%', display: 'flex' }}>
									{this.props.data.mcs}
								</span>
							</div>
						</div>
					</div>
				</td>
				<td className="wedding-details-column">
					<div
						style={{
							height: '100%',
							position: 'relative',
						}}
					>
						<div className="wedding-details wedding-details-center">
							<div className="upper-wed">
								<span className="date" style={{ width: '100%', display: 'flex' }}>
									<label className="switch">
										<input
											type="checkbox"
											checked={this.state.isShooter}
											onChange={(e) =>
												this.handleShooter(e, !this.state.isShooter)
											}
										/>
										<span className="slider round"></span>
									</label>
								</span>
							</div>
						</div>
					</div>
				</td>
				{_.map(this.props.columns, (column, key) => {
					if (_.has(column, 'workspaceId')) {
						return (
							<td
								className="wedding-details-column"
								onClick={this.props.handleTenantUserClick}
							>
								<div
									style={{
										height: '100%',
										position: 'relative',
									}}
								>
									<div className="wedding-details wedding-details-center">
										<div className="upper-wed">
											<span
												className="date"
												style={{ width: '100%', display: 'flex' }}
											>
												{_.findIndex(this.props.data.accessibleTenants, {
													workspaceId: column.workspaceId,
												}) !== -1 ? (
													_.filter(this.props.data.accessibleTenants, {
														workspaceId: column.workspaceId,
													})[0].role === 'default' ? (
														<CheckIcon />
													) : (
														<FullAccess />
													)
												) : (
													<CrossIcon />
												)}
											</span>
										</div>
									</div>
								</div>
							</td>
						);
					}
				})}
			</tr>
		);
	}
}

export default TenantUsersListTableRow;
